import { Modal, Button, Input, Card, Row, Col, message, Tooltip } from 'antd';
import RecommendedExpertCard from '../RecommendedExpertCard';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../../assets/scss/recommendationModal.scss';
import Loader from '../Loader';
import RecommendedExpertChatBot from '../RecommendedExpertChatbot';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import useResponsive from '../../../hooks/useBreakpoint';
import recommendExpertAvatar from '../../../assets/images/recommend-expert-modal-avatar.png';
import { postRequest, putRequest } from '../../../helpers/apiCall';
import { useNavigate, useParams } from 'react-router-dom';
import { set } from 'lodash';
const RecommendationModal = ({
  localStorageKey,
  data,
  setSelectedTab,
  setVisibleWhatsNextModal,
  backToRecommendation,
  setBackToRecommendation,
  isOpend = false

}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fromStaticMsg, setFromStaticMsg] = useState(false);
  const [query, setQuery] = useState('');
  const [showChatBot, setShowChatBot] = useState(false);
  const [messages, setMessages] = useState([
    // { sender: 'bot', text: 'Hi! How can I help you today?' }
  ]);
  const [fromInputBox, setFromInputBox] = useState(false);
  const dispatch = useDispatch();
  const sendBtnRef = useRef();
  const { recommendedExpertsList, isRecommendedExpertListLoading } = useSelector(
    state => state.expert,
  );

  const displayRecommendations = recommendedExpertsList || [];





  const onClose = () => {
    setIsVisible(false);
    setSelectedTab('request');
    if (backToRecommendation) {
      setBackToRecommendation(false);
      return;
    }

    setVisibleWhatsNextModal(true);
    if (!localStorage.getItem(localStorageKey)) {
      localStorage.setItem(localStorageKey, 'true');
    }
  };

  const handleSendQuery = () => {
    if (query.trim()) {
      dispatch({
        type: 'RECOMMENDED_EXPERT_LIST_REQUEST',
        questionId: data?.id,
        query: query.trim(),
      });
    }
    setFromStaticMsg(false);
  };

  const handleMessageButton = () => {
    setIsVisible(false);
    setSelectedTab('messaging');
  };
  const msgs = [
    'How were these experts selected for me?',
    `Tell me more about ${displayRecommendations[0]?.first_name} ${displayRecommendations[0]?.last_name[0]}.`,
    `${displayRecommendations[1]?.first_name ? `Tell me more about ${displayRecommendations[1]?.first_name} ${displayRecommendations[1]?.last_name[0]}.` : ''}`,
    `${displayRecommendations[2]?.first_name ? `Tell me more about ${displayRecommendations[2]?.first_name} ${displayRecommendations[2]?.last_name[0]}.` : ''}`,
    'How are prices determined?',
    'Is my information safe and private?',
    'Can I message all 3 experts at once to compare responses?',
    'Do you offer any discounts or free trials?',
  ];
  const navigate = useNavigate();
  const [needHelpLoading, setNeedHelpLoading] = useState(false);
  async function needHelpModal() {
    try {
      setNeedHelpLoading(true);
      const resp = await putRequest('need-help', {
        question_id: data?.id,
      });
      if (resp?.data?.success) {
        message.success(resp?.data?.message);
        setNeedHelp(false);
        navigate('/dashboard/customer', { replace: true });
      }
      setNeedHelpLoading(false);
    } catch (error) {
      message.error(error.message);
      setNeedHelpLoading(false);
    }
  }
  const modalRef = useRef();
  useEffect(() => {
    modalRef.current.scrollTop = modalRef.current.scrollHeight;
  }, [messages.length]);
  useEffect(() => {
    if (!showChatBot) {
      setQuery('');
    }
  }, [showChatBot]);

  const breakpoint = useResponsive();
  const [viewMore, setViewMore] = useState(false);
  const [needHelp, setNeedHelp] = useState(false);


  return (
    <Modal
      title={
        <div>
          <span>
            <strong>Your Recommendation Report</strong> We’ve carefully analyzed your needs and
            matched you with top experts who can help. Take a look, share your thoughts, and feel
            free to discuss it further—we’ll be with you all the way until you make the best
            decision.
          </span>
        </div>
      }
      open={isVisible || backToRecommendation}
      onCancel={onClose}
      footer={null}
      width={'90vw'}
      centered
      styles={{
        body: {
          padding: 0,
          height: 'auto',
          overflow: 'auto',
          // border:'2px solid red'
        },
        wrapper: {
          overflow: '',
        },
      }}
    >
      <div className="recommendation-modal">
        <Tooltip title="Need help choosing?" placement="bottom">
          <img
            src={recommendExpertAvatar}
            alt=""
            width={80}
            height={80}
            style={{
              position: 'absolute',
              top: 50,
              right: 50,
              border: '1px solid black',
              borderRadius: '50%',
              zIndex: 1,
              cursor: 'pointer',
            }}
            onClick={() => setNeedHelp(true)}
          />
        </Tooltip>
        <div ref={modalRef} className="expert-cards-section">
          <Row style={{ display: 'flex', position: 'relative', justifyContent: 'space-evenly' }}>
            {isRecommendedExpertListLoading ? (
              <div className="loading-container">
                <Loader />
              </div>
            ) : displayRecommendations.length > 0 ? (
              displayRecommendations.map((expert, index) => (
                <>
                  {index > 2 && !viewMore ? (
                    <>
                      {index === 3 && (
                        <Col
                          span={24}
                          style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}
                        >
                          <span
                            onClick={() => setViewMore(true)}
                            style={{ color: 'blue', cursor: 'pointer' }}
                          >
                            View all in {data?.category?.name.toUpperCase()}
                          </span>
                        </Col>
                      )}
                    </>
                  ) : (
                    <Col
                      key={expert.id}
                      xxl={7}
                      xl={7}
                      lg={10}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginBottom: '1rem' }}
                    >
                      <RecommendedExpertCard
                        expert={expert}
                        matchRank={index + 1}
                        questionDetails={data}
                        messageButton={() => handleMessageButton()}
                        localStorageKey={localStorageKey}
                        setBackToRecommendation={setBackToRecommendation}
                      />
                    </Col>
                  )}
                  {viewMore && displayRecommendations.length - 1 == index && (
                    <Col
                      span={24}
                      style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}
                    >
                      <span
                        onClick={() => setViewMore(false)}
                        style={{ color: 'blue', cursor: 'pointer' }}
                      >
                        View Less
                      </span>
                    </Col>
                  )}
                </>
              ))
            ) : (
              <div className="no-recommendations">No recommendations available</div>
            )}
          </Row>

          <Row style={{ margin: '60px' }}>
            {!showChatBot ? (
              <>
                {/* <Col className="" span={24} style={{ marginTop: '1rem' }}>
                  <span>
                    We'd love to hear your thoughts on the expert recommendations we provided!
                    Please feel free to type your feedback directly here or choose from one of these
                    options
                  </span>
                </Col> */}
                <Col span={24} className="d-flex " style={{ marginTop: '1rem' }}>
                  <Row style={{ width: '100%' }}>
                    <Col xs={24} md={24} lg={22} xl={22} xxl={22}>
                      <Input
                        value={query}
                        onChange={e => {
                          setQuery(e.target.value);
                          if (e.target.value) {
                            setFromInputBox(true);
                          }
                        }}
                        // placeholder="Let's discuss it further, and hear back your opinion"
                        placeholder="We'd love to hear your thoughts on the expert recommendations we provided!
                    Please feel free to type your feedback directly here or choose from one of these
                    options"
                        // onPressEnter={handleSendQuery}
                        style={{ flex: 1, height: '100%' }}
                      />
                    </Col>
                    <Col
                      style={{
                        marginTop:
                          (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md') &&
                          '1rem',
                      }}
                      xs={24}
                      md={24}
                      lg={2}
                      xl={2}
                      xxl={2}
                    >
                      <Button
                        style={{ width: '100%' }}
                        type="primary"
                        // onClick={handleSendQuery}
                        onClick={() => {
                          if (query) {
                            setShowChatBot(true);
                          } else {
                            message.error('Please enter a message');
                          }
                        }}
                        loading={isRecommendedExpertListLoading}
                        className="send-button"
                        ref={sendBtnRef}
                      >
                        Send <i className="fa-solid fa-paper-plane" style={{}}></i>
                      </Button>
                    </Col>
                  </Row>
                </Col>
                {displayRecommendations.length > 0 ? (
                  msgs.map((message, index) => (
                    <>
                      {!!message.length && (
                        <span
                          key={index}
                          className="recommended-expert-suggestion-capsule"
                          onClick={() => {
                            setShowChatBot(true);
                            setQuery(message);
                            // setFromStaticMsg(true);
                          }}
                        >
                          {message}
                        </span>
                      )}
                    </>
                  ))
                ) : (
                  <>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <Loader />
                    </Col>
                  </>
                )}
              </>
            ) : (
              <>

                <Col span={24} >
                  <RecommendedExpertChatBot
                    messages={messages}
                    setMessages={setMessages}
                    setShowChatBot={setShowChatBot}
                    query={query}
                    fromInputBox={fromInputBox}
                    setFromInputBox={setFromInputBox}
                    displayRecommendations={displayRecommendations}
                  />
                </Col>
              </>
            )}
          </Row>
        </div>
        <Modal
          okButtonProps={{ disabled: needHelpLoading, loading: needHelpLoading }}
          centered
          open={needHelp}
          onCancel={() => setNeedHelp(false)}
          onOk={() => needHelpModal(false)}
          okText={'Okay'}
        >
          <h1>Need Help?</h1>
          <p>Not sure which expert is right for you?</p>
          <p>Our team will review your request and recommend the best match.</p>
        </Modal>
      </div>
    </Modal>
  );
};

export default RecommendationModal;
